export default {
    data: () => ({
        translations: {
            addRegistrationPlan: {
                el: "Προσθήκη πλάνου συνδρομής",
                en: "Add Subscription Plan",
                it: "Aggiungi piano di abbonamento"
            },
            addCompanySubscriptionPlan: {
                el: "Προσθήκη Πλάνου Συνδρομής Εταιρίας",
                en: "Add Company Subscription Plan",
                it: "Add Company Subscription Plan"
            },
            name: {
                el: "Name",
                en: "Name",
                it: "Nome"
            },
            plan_type: {
                el: "Τύπος Πλάνου",
                en: "Plan Type",
                it: "Tipo di piano"
            },
            description: {
                el: "Περιγραφή",
                en: "Description",
                it: "Descrizione"
            },
            price: {
                el: "Τιμή",
                en: "Price",
                it: "Prezzo"
            },
            ratio: {
                el: "Αναλογία",
                en: "Ratio",
                it: "Rapporto"
            },
            minimum_price: {
                el: "Ελάχιστη τιμή",
                en: "Minimum Price",
                it: "Prezzo minimo"
            },
            price_type: {
                el: "",
                en: "Price Type",
                it: ""
            },
            plan_duration: {
                el: "Διάρκεια",
                en: "Duration",
                it: "Durata"
            },
            payment_cycle: {
                el: "Κύκλος πληρωμών",
                en: "Payment Cycle",
                it: "Ciclo di pagamento"
            },
            extra_properties: {
                el: "Επιπλέον ιδιότητες",
                en: "Extra Properties",
                it: "Proprietà aggiuntive"
            },
            reward_points: {
                el: "Πόντοι επιβράβευσης",
                en: "Reward Points",
                it: "Punti di ricompensa"
            },
            public: {
                el: "Δημόσιο",
                en: "Public",
                it: "Pubblico"
            },
            reward_type: {
                el: "Τύπος επιβράβευσης",
                en: "Reward Type",
                it: "Tipo di ricompensa"
            },
            actions: {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni"
            },
            update: {
                el: "Ενημέρωση",
                en: "Update",
                it: "Aggiornamento"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancellare"
            },
            showSubscriptionPlanInfo: {
                el: "",
                en: "Show Subscription Plan Info",
                it: ""
            },
            subscriptionPlanInfo:{
                el: "",
                en: "Subscription Plan Info",
                it: "" 
            },
            modalTitle1:{
                el: "Προσθήκη πλάνου συνδρομής",
                en: "Add Subscription Plan",
                it: "Aggiungi piano di abbonamento" 
            },
            modalTitle2:{
                el: "Ενημέρωση",
                en: "Update Subscription Plan",
                it: "Aggiornamento" 
            },
            planName:{
                el: "Όνομα Πλάνου",
                en: "Plan Name",
                it: "Nome del piano" 
            },
            planDescription:{
                el: "Περιγραφή Πλάνου",
                en: "Plan Description",
                it: "Descrizione del piano" 
            },
            planType:{
                el: "Τύπος Πλάνου",
                en: "Subscription Plan Type",
                it: "Tipo di piano" 
            },
            planPaymentCycle:{
                el: "Κύκλος πληρωμών",
                en: "Subscription Plan Payment Cycle",
                it: "Ciclo di pagamento" 
            },
            planPaymentType:{
                el: "Subscription Plan Payment Type",
                en: "Subscription Plan Payment Type",
                it: "Subscription Plan Payment Type" 
            },
            planDuration:{
                el: "Subscription Plan Duration",
                en: "Subscription Plan Duration",
                it: "Subscription Plan Duration" 
            },
            planPrice:{
                el: "Ποσό",
                en: "Plan Price",
                it: "Importo" 
            },
            planMinPrice:{
                el: "Ελάχιστη τιμή",
                en: "Plan Minimum Price",
                it: "Prezzo minimo" 
            },
            rewardPoints:{
                el: "Πόντοι Eπιβράβευσης",
                en: "Reward Points",
                it: "Punti di ricompensa" 
            },
            rewardType:{
                el: "Τύπος Eπιβράβευσης",
                en: "Reward Type",
                it: "Tipo di ricompensa" 
            },
            paymentMethods:{
                el: "Μέθοδοι Πληρωμών",
                en: "Payment Methods",
                it: "Metodi di pagamento" 
            },
            publish:{
                el: "Δημοσίευση",
                en: "Publish",
                it: "Pubblico" 
            },
            interval: {
                el: "",
                en: "Interval",
                it: "" 
            },
            intervalCount: {
                el: "",
                en: "Interval Count",
                it: "" 
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            },
            includeVat: {
                el: "με ΦΠΑ",
                en: "after VAT",
                it: "dopo l'IVA"
            },
            permissions: {
                el: "Δικαιώματα",
                en: "Permissions",
                it: "Permessi"
            },
            attributes: {
                el: "Ιδιότητες",
                en: "Attributes",
                it: "Attributi" 
            },
        }
    })
};
